export default __webpack_public_path__ + "static/media/wetland_sprinkler.e2557aa1.jpg";